import React from 'react';
import "../../App.scss";

function plus() {
  return (
    <div style={{ height: '100%', overflow: 'scroll' }}> 
      <a href="/">
    <img  src={require("../header/logo.png")} alt={"Test"} width="100px" height="50px"  />
    </a>
<h1>Future Research Fields</h1>
      </div>
  );
}

export default plus;